import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { formatDateValueToISOString } from "@/features/FormCard/utils";
import { z } from "zod";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { OptionList } from "@/types/optionList";

export const FilterF1StrategyMetadataSchema = z.object({
  strategy_id_contains: z.string().nullable().optional(),
  sub_asset_class_contains: z.string().nullable().optional(),
  fund_esg_rating_level_contains: z.string().nullable().optional(),
  dedicated_fund_contains: z.string().nullable().optional(),
  created_at_from: z.any().optional().transform(formatDateValueToISOString),
  created_at_to: z.any().optional().transform(formatDateValueToISOString),
  updated_at_from: z.any().optional().transform(formatDateValueToISOString),
  updated_at_to: z.any().optional().transform(formatDateValueToISOString),
});

export type FilterF1StrategyMetadataSchema = z.infer<
  typeof FilterF1StrategyMetadataSchema
>;

// Define the filter options
export const subAssetClassOptions = new OptionList(
  { value: "office", label: "Bureaux" },
  { value: "residential", label: "Résidentiel" },
  { value: "other", label: "Autres" },
  { value: "cash_sci", label: "Cash immobilier" },
);

export const dedicatedFundOptions = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const fundEsgRatingOptions = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const fields: Field[] = [
  {
    name: "strategy_id_contains",
    label: "Strategy ID",
    type: "input",
  },
  {
    name: "sub_asset_class_contains",
    label: "Sub Asset Class",
    type: "select",
    options: subAssetClassOptions,
    useTranslation: false,
  },
  {
    name: "fund_esg_rating_level_contains",
    label: "Fund ESG Rating",
    type: "select",
    options: fundEsgRatingOptions,
    useTranslation: false,
  },
  {
    name: "dedicated_fund_contains",
    label: "Dedicated Fund",
    type: "select",
    options: dedicatedFundOptions,
    useTranslation: false,
  },

  {
    name: "creationDate",
    type: "dateRange",
    label: "Created",
    from: { name: "created_at_from" },
    to: { name: "created_at_to" },
    copy_from_to_when_to_empty: true,
    col_span: 2,
  },

  {
    name: "updateDate",
    type: "dateRange",
    label: "Updated",
    from: { name: "updated_at_from" },
    to: { name: "updated_at_to" },
    copy_from_to_when_to_empty: true,
    col_span: 2,
  },
];

export function FilterF1StrategyMetadata() {
  return (
    <FilterTable
      columns={2}
      client={Clients.F1_QUANTILIA}
      schema={FilterF1StrategyMetadataSchema}
      tableName={Tables.F1_STRATEGY_METADATA}
      customBuildPath={() => Tables.F1_STRATEGY_METADATA}
      fields={fields}
    />
  );
}
